import React from 'react';

const LegacyLabel = () => <span className="ws-legacy-label">LEGACY</span>;

export default LegacyLabel;
